<template>
  <div>
    <a-select
      show-search
      :autoFocus="true"
      placeholder="Année scolaire"
      option-filter-prop="children"
      style="width: 300%"
      :filter-option="filterOption"
      @change="handleChange"
      :default-value="settings.activeSchoolarYear"
      v-model="settings.activeSchoolarYear"
    >
      <a-select-option
        :value="schoolarYear._id"
        v-for="schoolarYear in settings.schoolarYears"
        :key="schoolarYear._id"
      >
        {{ schoolarYear.name }}
      </a-select-option>
    </a-select>
  </div>
</template>
<script>
/* eslint-disable */
import store from "store";
import { mapState } from "vuex";
import CuiSidebar from "@/components/cleanui/layout/Sidebar";
export default {
  name: "SchoolarYearLayout",
  components: { CuiSidebar },
  computed: mapState(["settings"]),
  methods: {
    handleChange(value) {
      store.set("activeSchoolarYear", value);
      this.$store.commit("settings/CHANGE_SETTING", {
        setting: "activeSchoolarYear",
        value: value,
      });
      window.location.reload();
    },
    handleBlur() {},
    handleFocus() {},
    filterOption(input, option) {
      return (
        option.componentOptions.children[0].text
          .toLowerCase()
          .indexOf(input.toLowerCase()) >= 0
      );
    },
  },
};
</script>
